import React from "react";
import { withBottombar } from "../../HOCs";
import { DatePickers } from "./datepickers";
class DatePickerTestParent extends React.Component {
  render() {
    return <DatePickers />;
  }
}
export default withBottombar(DatePickerTestParent);